import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import FormikInput from "components/common/FormikInput";
import { Input } from "components/bootstrap";
import { TimezoneSelect } from "components/common";
import HoverForHelp from "components/common/HoverForHelp";
const DescriptionTextArea = styled(FormikInput)`
  resize: vertical;
`;
const Overview = ({ editAllowed, scopeLocked = false }) => {
  const { t } = useTranslation("enterprise_report");
  const lockedByScope = !editAllowed || scopeLocked;
  const timezoneLabel = /* @__PURE__ */ React.createElement(React.Fragment, null, t("overview.timezone"), /* @__PURE__ */ React.createElement(HoverForHelp, { iconSize: "sm", title: t("overview.timezone"), placement: "right" }, t("overview.timezone_help")));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormikInput, { label: t("overview.title"), name: "title", id: "title", required: true, disabled: lockedByScope }), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("overview.subtitle"), " ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(", t("overview.optional"), ")")),
      name: "subtitle",
      id: "subtitle",
      disabled: lockedByScope
    }
  ), /* @__PURE__ */ React.createElement(
    DescriptionTextArea,
    {
      type: "textarea",
      rows: 3,
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("overview.description"), " ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(", t("overview.optional"), ")")),
      name: "description",
      id: "description",
      disabled: lockedByScope
    }
  ), /* @__PURE__ */ React.createElement(Field, { name: "timezone" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(Input, { id: "timezone-select", label: timezoneLabel, disabled: !editAllowed }, /* @__PURE__ */ React.createElement(
    TimezoneSelect,
    {
      value,
      name: "timezone",
      onChange: (newValue) => onChange({ target: { name, value: newValue } }),
      disabled: !editAllowed
    }
  ))));
};
export default Overview;
